module.exports = __webpack_public_path__ + "assets/img/mroot@2x.bb7af8e3.png";